module.exports = __webpack_public_path__ + "static/media/expressiveSpace-large.7625252a.jpg";